// extracted by mini-css-extract-plugin
module.exports = {"wrap":"DownloadAppBlock_wrap__qkkb4","cont":"DownloadAppBlock_cont__2bZqk","btn":"DownloadAppBlock_btn__1qe9H"};